import "./Copyrights.css";

export default function Copyrights() {
  return <div className="copy-rights">© {new Date().getFullYear()} The Magnum Ice Cream Company</div>;
}
